import { ITicketGroupResponse } from "./ticket-group-response";

export interface ITicketGroupUserResponse {
    data: {
        id: number;
        firstName: string;
        lastName: string;
        email: string;
        password: string;
        username: string;
        centerId: number;
        groupId: number;
        group: ITicketGroupResponse;
    }
}